<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="backButtonPressed()" defaultHref="/"></ion-back-button>
    </ion-buttons>
    <ion-title>{{username}}s {{"ascent-list-page.ticklist" | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <my-ascent-list username="{{username}}"></my-ascent-list>
</ion-content>
